function getElementTarget(event) {
  const target = event.target;

  if (target instanceof Element) {
    return target;
  }

  if (target && target.parentElement instanceof Element) {
    return target.parentElement;
  }

  return null;
}

function handleShareClick(button) {
  if (!button) return;

  const title = document.title;
  const text = "Ich möchte dieses Produkt bei ShopLC empfehlen";
  const url = window.location.href;

  if (navigator.share) {
    navigator
      .share({
        title,
        text,
        url
      })
      .catch(function (err) {
        console.log("Share cancelled or failed", err);
      });

    return;
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(url)
      .then(function () {
        alert("Link copied to clipboard");
      })
      .catch(function (err) {
        console.log("Clipboard copy failed", err);
      });

    return;
  }

  console.log("Clipboard API is not available");
}

document.addEventListener("click", function (e) {
  const target = getElementTarget(e);
  if (!target) return;

  const shareButton = target.closest(".share-icon-js");
  if (shareButton) {
    handleShareClick(shareButton);
    return;
  }
});

(function () {
  const SELECTORS = {
    root: '[data-product-details]',
    price: '[data-pdp-price]',
    compare: '[data-pdp-compare]',
    discountPill: '[data-pdp-discount-pill]',
    discountText: '[data-pdp-discount]',
    pointsWrap: '[data-pdp-points]',
    pointsValue: '[data-pdp-points-value]',
    budgetpayWrap: '[data-pdp-budgetpay]',
    budgetpayValue: '[data-pdp-budgetpay-value]',
    couponCode: '[data-pdp-coupon-code]',
    couponCopy: '[data-pdp-coupon-copy]',
    variantsJson: '[data-product-variants-json]',
    title: '[data-pdp-title]',
    variantTitlesJson: '[data-product-variant-titles]',
    shippingText: '[data-pdp-shipping-text]',
    shippingConfig: '[data-preorder-shipping-config]',
    pickerForm: '.variant-picker__form',
    fieldset: 'fieldset.variant-option[data-option-position]',
    radioChecked: 'input[type="radio"]:checked'
  };

  function formatMoney(cents, useCurrencyCode) {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = 'de-DE';
    const amount = (Number(cents) || 0) / 100;
    const hasDecimals = amount % 1 !== 0;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
        ...(useCurrencyCode ? { currencyDisplay: 'code' } : {})
      }).format(amount);
    } catch (error) {
      return hasDecimals
        ? amount.toFixed(2).replace('.', ',')
        : String(Math.round(amount));
    }
  }

  function getDiscountLabel(price, compareAt, threshold = 0, useCurrencyCode = false) {
    const discountAmount = compareAt - price;

    if (threshold && discountAmount >= threshold) {
      return {
        pill: `${formatMoney(discountAmount, useCurrencyCode)} Rabatt`,
        text: `(-${formatMoney(discountAmount, useCurrencyCode)})`
      };
    }

    const pct = Math.round((discountAmount * 100) / compareAt);

    return {
      pill: `${pct}% Rabatt`,
      text: `(-${pct}%)`
    };
  }

  function normalizeValue(value) {
    return String(value == null ? '' : value);
  }

  function getVariantTitlesData(root) {
    if (!root) return null;

    const el = root.querySelector(SELECTORS.variantTitlesJson);
    if (!el) return null;

    try {
      return JSON.parse(el.textContent || '{}');
    } catch (error) {
      console.warn('[product-details] title json parse failed', error);
      return null;
    }
  }

  function getResolvedTitle(root, variant) {
    if (!root) return '';

    const titleData = getVariantTitlesData(root);
    const titleEl = root.querySelector(SELECTORS.title);

    const fallbackTitle =
      titleData?.productTitle ||
      titleEl?.dataset.productTitle ||
      '';

    if (!variant?.id) {
      return fallbackTitle;
    }

    const variantTitleData = titleData?.variants?.[String(variant.id)];

    const seoName = normalizeValue(variantTitleData?.seoName).trim();
    const customTitle = normalizeValue(variantTitleData?.variantTitle).trim();

    return seoName || customTitle || fallbackTitle;
  }

  function getSelectedOptions(variantPicker) {
    const form = variantPicker?.querySelector(SELECTORS.pickerForm);
    if (!form) return [];

    const values = [];

    form.querySelectorAll(SELECTORS.fieldset).forEach((fieldset) => {
      const position = Number(fieldset.dataset.optionPosition);
      const checked = fieldset.querySelector(SELECTORS.radioChecked);
      values[position] = checked ? normalizeValue(checked.value) : '';
    });

    return values;
  }

  function findVariantByOptions(variants, selectedOptions) {
    if (!Array.isArray(variants) || !variants.length) return null;
    if (!Array.isArray(selectedOptions) || !selectedOptions.length) return null;

    return (
      variants.find((variant) => {
        const variantOptions = Array.isArray(variant.options)
          ? variant.options.map(normalizeValue)
          : [];

        if (variantOptions.length !== selectedOptions.length) return false;

        return variantOptions.every((value, index) => {
          return value === normalizeValue(selectedOptions[index]);
        });
      }) || null
    );
  }

  function updatePriceUI(root, variant) {
    if (!root || !variant) return;

    const priceEl = root.querySelector(SELECTORS.price);
    const compareEl = root.querySelector(SELECTORS.compare);
    const discountPillEl = root.querySelector(SELECTORS.discountPill);
    const discountTextEl = root.querySelector(SELECTORS.discountText);

    const useCurrencyCode = String(root.dataset.currencyCodeEnabled) === 'true';

    const price = Number(variant.price || 0);
    const compareAt = Number(variant.compare_at_price || 0);
    const hasDiscount = compareAt > price && compareAt > 0;

    if (priceEl) {
      priceEl.innerHTML = formatMoney(price, useCurrencyCode);
    }

    if (compareEl) {
      if (hasDiscount) {
        compareEl.innerHTML = formatMoney(compareAt, useCurrencyCode);
        compareEl.style.display = '';
      } else {
        compareEl.innerHTML = '';
        compareEl.style.display = 'none';
      }
    }

    const threshold = Number(root.dataset.discountThreshold || 0);

    const discountLabel = hasDiscount
      ? getDiscountLabel(price, compareAt, threshold, useCurrencyCode)
      : null;

    if (discountPillEl) {
      if (hasDiscount && discountLabel) {
        discountPillEl.textContent = discountLabel.pill;
        discountPillEl.style.display = '';
      } else {
        discountPillEl.textContent = '';
        discountPillEl.style.display = 'none';
      }
    }

    if (discountTextEl) {
      if (hasDiscount && discountLabel) {
        discountTextEl.textContent = discountLabel.text;
        discountTextEl.style.display = '';
      } else {
        discountTextEl.textContent = '';
        discountTextEl.style.display = 'none';
      }
    }
  }

  function updatePointsUI(root, variant) {
    if (!root || !variant) return;

    const pointsWrap = root.querySelector(SELECTORS.pointsWrap);
    const pointsValueEl = root.querySelector(SELECTORS.pointsValue);

    if (!pointsWrap || !pointsValueEl) return;

    const coef = Number(pointsWrap.dataset.pointsCoef || 1);
    const price = Number(variant.price || 0);
    const basePrice = price / 100;
    const points = Math.floor(basePrice) * coef;

    pointsValueEl.textContent = String(points);
  }

  function updateBudgetpayUI(root, variant) {
    if (!root || !variant) return;

    const budgetpayWrap = root.querySelector(SELECTORS.budgetpayWrap);
    const budgetpayValueEl = root.querySelector(SELECTORS.budgetpayValue);

    if (!budgetpayWrap || !budgetpayValueEl) return;

    const installments = Number(budgetpayWrap.dataset.installments || 0);
    if (!installments || installments < 1) return;

    const useCurrencyCode = String(root.dataset.currencyCodeEnabled) === 'true';
    const price = Number(variant.price || 0);
    const installmentAmount = Math.round(price / installments);

    budgetpayValueEl.textContent = `${installments} × ${formatMoney(
      installmentAmount,
      useCurrencyCode
    )}`;
  }

  function setupCouponCopy(root) {
    const codeEl = root.querySelector(SELECTORS.couponCode);
    const copyBtn = root.querySelector(SELECTORS.couponCopy);

    if (!codeEl || !copyBtn || copyBtn.dataset.copyBound === 'true') return;

    copyBtn.dataset.copyBound = 'true';

    const originalText = copyBtn.textContent;

    copyBtn.addEventListener('click', async function () {
      const code = codeEl.textContent?.trim() || '';
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
        copyBtn.textContent = 'Kopiert';

        window.setTimeout(function () {
          copyBtn.textContent = originalText;
        }, 1200);
      } catch (error) {
        console.warn('[product-details] coupon copy failed', error);
      }
    });
  }

  function updateProductTitleUI(root, variant) {
    if (!root) return;

    const productTitleEl = root.querySelector(SELECTORS.title);
    if (!productTitleEl) return;

    const nextTitle = getResolvedTitle(root, variant);
    if (!nextTitle) return;

    productTitleEl.textContent = nextTitle;
  }

  function getPreorderShippingConfig(source) {
    var configEl = source ? source.querySelector(SELECTORS.shippingConfig) : null;
    if (!configEl) return null;
    try {
      return JSON.parse(configEl.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function computePreorderShippingText(config) {
    if (!config || !config.isPreorder || !config.inStockDate) {
      return config && config.staticText ? config.staticText : '';
    }

    var germanMonths = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
    var inStockDate = new Date(config.inStockDate + 'T00:00:00');
    var now = new Date();
    now.setHours(0, 0, 0, 0);

    if (isNaN(inStockDate.getTime()) || inStockDate <= now) {
      return config.staticText || '';
    }

    var startDate = new Date(inStockDate.getTime() - 86400000);
    var rangeEnd = Number(config.rangeEndDays) || 0;
    var endDate = new Date(startDate.getTime() + rangeEnd * 86400000);

    var startMonth = germanMonths[startDate.getMonth()];
    var startDay = startDate.getDate();
    var endMonth = germanMonths[endDate.getMonth()];
    var endDay = endDate.getDate();

    return 'Voraussichtliche Lieferung: <span>' + startMonth + ' ' + startDay + ' - ' + endMonth + ' ' + endDay + '</span>';
  }

  function updateShippingUI(root, newProductHTML) {
    if (!root) return;

    var shippingEl = root.querySelector(SELECTORS.shippingText);
    if (!shippingEl) return;

    if (newProductHTML) {
      var newConfigEl = newProductHTML.querySelector(SELECTORS.shippingConfig);
      if (newConfigEl) {
        var currentConfigEl = root.querySelector(SELECTORS.shippingConfig);
        if (currentConfigEl) {
          currentConfigEl.textContent = newConfigEl.textContent;
        }
      }
    }

    var config = getPreorderShippingConfig(root);
    if (!config) return;

    var newText = computePreorderShippingText(config);
    shippingEl.innerHTML = newText;
  }

  function updateProductDescriptionsUI(root, newProductHTML) {
    if (!root || !newProductHTML) return;

    const newAccordionsSection = newProductHTML?.querySelector(".pdp-accordion");

    if (!newAccordionsSection) return;

    const newAccordionsHTML = newAccordionsSection.outerHTML;
    const currentAccordionSection = root.querySelector(".pdp-accordion");

    if (newAccordionsHTML && currentAccordionSection) {
      currentAccordionSection.outerHTML = newAccordionsHTML;

      document.dispatchEvent(new CustomEvent("variantUpdated:reinitBuybox"));
    }
  }

  function initProductDetails(root) {
    if (!root || root.dataset.productDetailsInitialized === 'true') return;

    const sectionId = root.dataset.sectionId;
    const productId = root.dataset.productId;

    const variantsJsonEl = root.querySelector(SELECTORS.variantsJson);
    if (!variantsJsonEl) {
      console.warn('[product-details] variants json not found', root);
      return;
    }

    let variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent || '[]');
    } catch (error) {
      console.warn('[product-details] variants json parse failed', error);
      return;
    }

    const variantPicker =
      document.querySelector(
        `variant-picker[data-section-id="${sectionId}"][data-product-id="${productId}"]`
      ) ||
      document.querySelector(`variant-picker[data-section-id="${sectionId}"]`) ||
      document.querySelector('variant-picker[data-template-product-match="true"]');

    if (!variantPicker) {
      console.warn('[product-details] variant picker not found', {
        sectionId,
        productId
      });
      return;
    }

    const syncFromPicker = function () {
      const selectedOptions = getSelectedOptions(variantPicker);
      const variant = findVariantByOptions(variants, selectedOptions);

      if (!variant) {
        console.warn('[product-details] no variant for selected options', {
          sectionId,
          productId,
          selectedOptions
        });
        return;
      }

      updateProductTitleUI(root, variant);
      updatePriceUI(root, variant);
      updatePointsUI(root, variant);
      updateBudgetpayUI(root, variant);
      updateShippingUI(root, null);
    };

    const onVariantUpdate = function (event) {
      const variant = event?.detail?.resource;
      const newProductHTML = event?.detail?.data?.html;

      if (newProductHTML) {
        updateProductDescriptionsUI(root, newProductHTML);
        updateShippingUI(root, newProductHTML);
      }

      if (!variant || !variant.id) {
        syncFromPicker();
        return;
      }

      updateProductTitleUI(root, variant);
      updatePriceUI(root, variant);
      updatePointsUI(root, variant);
      updateBudgetpayUI(root, variant);
      updateShippingUI(root, newProductHTML);
    };

    syncFromPicker();

    variantPicker.addEventListener('change', syncFromPicker);

    document.addEventListener('change', function (event) {
      if (!variantPicker.contains(event.target)) return;
      syncFromPicker();
    });

    variantPicker.addEventListener('variant:update', onVariantUpdate);
    root.addEventListener('variant:update', onVariantUpdate);
    document.addEventListener('variant:update', onVariantUpdate);

    setupCouponCopy(root);

    root.dataset.productDetailsInitialized = 'true';
  }

  function initAllProductDetails() {
    document.querySelectorAll(SELECTORS.root).forEach(initProductDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductDetails);
  } else {
    initAllProductDetails();
  }

  document.addEventListener('shopify:section:load', initAllProductDetails);
})();

document.addEventListener("DOMContentLoaded", () => {
  function findKlarnaLink() {
    const placement = document.querySelector("klarna-placement");
    if (!placement) return null;

    if (placement.shadowRoot) {
      return placement.shadowRoot.querySelector(".link");
    }

    const child = placement.firstElementChild;
    if (child && child.shadowRoot) {
      return child.shadowRoot.querySelector(".link");
    }

    return null;
  }

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".klarna-icon-js");
    if (!trigger) return;

    const klarnaLink = findKlarnaLink();

    if (klarnaLink) {
      klarnaLink.click();
    } else {
      console.warn("Klarna link not found.");
    }
  });

  const stickyBar = document.querySelector("[data-mobile-sticky-atc]");
  if (!stickyBar) return;

  const stickyButton = stickyBar.querySelector("[data-sticky-atc-button]");
  const stickyPrice = stickyBar.querySelector("[data-sticky-price]");
  const stickyError = stickyBar.querySelector("[data-sticky-atc-error]");
  const productJsonEl = document.querySelector("[data-sticky-product-json]");

  const productForm = document.querySelector('product-form-component');
  const mainForm = productForm?.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  const mainAddToCartButton =
    productForm?.querySelector('button[name="add"], [type="submit"][name="add"], [type="submit"]');
  const variantInput = productForm?.querySelector('input[name="id"], input[ref="variantId"]');

  if (!mainForm || !mainAddToCartButton || !variantInput || !productJsonEl || !stickyButton || !stickyPrice) {
    return;
  }

  let productData = null;

  try {
    productData = JSON.parse(productJsonEl.textContent);
  } catch (error) {
    console.error("Failed to parse product JSON", error);
    return;
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || "EUR";
    const locale = "de-DE";
    const amount = (Number(cents) || 0) / 100;
    const hasDecimals = amount % 1 !== 0;

    try {
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0
      }).format(amount);
    } catch (error) {
      return hasDecimals
        ? `${amount.toFixed(2).replace(".", ",")} €`
        : `${Math.round(amount)} €`;
    }
  }

  function getVariantById(variantId) {
    return productData?.variants?.find((item) => Number(item.id) === Number(variantId)) || null;
  }

  function getStickyDiscountLabel(price, compareAt, threshold = 0) {
    const discountAmount = compareAt - price;

    if (threshold && discountAmount >= threshold) {
      return `${formatMoney(discountAmount)} Rabatt`;
    }

    const pct = Math.round((discountAmount * 100) / compareAt);
    return `${pct}% Rabatt`;
  }

  function renderStickyPrice(variant) {
    const price = Number(variant.price || 0);
    const compareAt = Number(variant.compare_at_price || 0);
    const hasDiscount = compareAt > price && compareAt > 0;
    const threshold = Number(
      stickyBar?.dataset?.discountThreshold || 0
    );

    if (hasDiscount) {
      const discountLabel = getStickyDiscountLabel(price, compareAt, threshold);

      stickyPrice.innerHTML = `
        <span class="mobile-sticky-atc__price-current">${formatMoney(price)}</span>
        <span class="mobile-sticky-atc__vat">Inkl. MwSt.</span>
        <span class="mobile-sticky-atc__price-compare">${formatMoney(compareAt)}</span>
        <span class="mobile-sticky-atc__discount">${discountLabel}</span>
      `;
    } else {
      stickyPrice.innerHTML = `
        <span class="mobile-sticky-atc__price-current">${formatMoney(price)}</span>
        <span class="mobile-sticky-atc__vat">Inkl. MwSt.</span>
      `;
    }
  }

  function showStickyError(message) {
    if (!stickyError) return;
    stickyError.textContent = message || "";
    stickyError.classList.toggle("hidden", !message);
  }

  function clearStickyError() {
    if (!stickyError) return;
    stickyError.textContent = "";
    stickyError.classList.add("hidden");
  }

  function animateStickyButton() {
    if (!stickyButton) return;

    stickyButton.classList.add("is-added");
    stickyButton.classList.add("active");

    const iconContainer = stickyButton.querySelector(".icon-container");
    if (iconContainer && stickyButton.dataset.added) {
      iconContainer.textContent = stickyButton.dataset.added;
    }

    window.clearTimeout(stickyButton._stickyAnimationTimer);
    stickyButton._stickyAnimationTimer = window.setTimeout(() => {
      stickyButton.classList.remove("is-added");
      stickyButton.classList.remove("active");

      if (iconContainer && stickyButton.dataset.addToCartCaption) {
        iconContainer.textContent = stickyButton.dataset.addToCartCaption;
      }
    }, 3000);
  }

  function resetStickyButtonState() {
    stickyButton.classList.remove("is-added");
    stickyButton.classList.remove("active");

    const iconContainer = stickyButton.querySelector(".icon-container");
    if (iconContainer && stickyButton.dataset.addToCartCaption) {
      iconContainer.textContent = stickyButton.dataset.addToCartCaption;
    }
  }

  function updateStickyBar() {
    const variant = getVariantById(variantInput.value);
    if (!variant) return;

    renderStickyPrice(variant);
    stickyButton.disabled = !variant.available;
  }

  stickyButton.addEventListener("click", () => {
    clearStickyError();
    productForm.dataset.stickyTriggered = "true";
    mainAddToCartButton.click();
  });

  mainForm.addEventListener("change", () => {
    clearStickyError();
    resetStickyButtonState();
    requestAnimationFrame(updateStickyBar);
  });

  document.addEventListener("variant:change", () => {
    clearStickyError();
    resetStickyButtonState();
    updateStickyBar();
  });

  document.addEventListener("variant:update", function (event) {
    const variant = event?.detail?.resource;
    clearStickyError();
    resetStickyButtonState();

    if (!variant || !variant.id) {
      updateStickyBar();
      return;
    }

    renderStickyPrice(variant);
    stickyButton.disabled = !variant.available;
  });

  document.addEventListener("cart:updated", function () {
    if (productForm.dataset.stickyTriggered === "true") {
      animateStickyButton();
      productForm.dataset.stickyTriggered = "false";
    }
  });

  document.addEventListener("sticky-atc:error", function (event) {
    showStickyError(event.detail?.message || "");
    resetStickyButtonState();
    productForm.dataset.stickyTriggered = "false";
  });

  function isActuallyVisible(element) {
    if (!element) return false;

    const styles = window.getComputedStyle(element);

    return (
      styles.display !== "none" &&
      styles.visibility !== "hidden" &&
      styles.opacity !== "0" &&
      element.offsetParent !== null
    );
  }

  function getStickyVisibilityTargets() {
    return {
      priceTargets: [
        document.querySelector(".pdp-figma__price-row"),
        document.querySelector(".pdp-buybox__price")
      ].filter(Boolean),

      atcTargets: [
        mainAddToCartButton,
        ...Array.from(document.querySelectorAll(".bmsm__add-to-cart[data-role='add-to-cart-button']"))
      ].filter(Boolean)
    };
  }

  function setupStickyVisibilityObservers() {
    if (stickyBar._priceObserver) {
      stickyBar._priceObserver.disconnect();
    }

    if (stickyBar._atcObserver) {
      stickyBar._atcObserver.disconnect();
    }

    const visiblePriceTargets = new Set();
    const visibleAtcTargets = new Set();

    const updateStickyVisibilityState = () => {
      const hasVisiblePrice = Array.from(visiblePriceTargets).some((el) => isActuallyVisible(el));
      const hasVisibleAtc = Array.from(visibleAtcTargets).some((el) => isActuallyVisible(el));

      stickyBar.classList.toggle("is-hidden-by-price", hasVisiblePrice);
      stickyBar.classList.toggle("is-hidden-by-atc", hasVisibleAtc);
    };

    const stickyHeight = stickyBar.offsetHeight || 0;

    const priceObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visiblePriceTargets.add(entry.target);
          } else {
            visiblePriceTargets.delete(entry.target);
          }
        });

        updateStickyVisibilityState();
      },
      {
        threshold: 0.15,
        rootMargin: `0px 0px -${stickyHeight}px 0px`
      }
    );

    const atcObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleAtcTargets.add(entry.target);
          } else {
            visibleAtcTargets.delete(entry.target);
          }
        });

        updateStickyVisibilityState();
      },
      {
        threshold: 0.15
      }
    );

    const { priceTargets, atcTargets } = getStickyVisibilityTargets();

    priceTargets.forEach((target) => priceObserver.observe(target));
    atcTargets.forEach((target) => atcObserver.observe(target));

    stickyBar._priceObserver = priceObserver;
    stickyBar._atcObserver = atcObserver;

    requestAnimationFrame(updateStickyVisibilityState);
  }

  setupStickyVisibilityObservers();

  window.addEventListener("load", () => {
    setTimeout(() => {
      setupStickyVisibilityObservers();
    }, 100);
  });

  document.addEventListener("variant:update", function () {
    requestAnimationFrame(() => {
      setupStickyVisibilityObservers();
    });
  });

  document.addEventListener("variantUpdated:reinitBuybox", function () {
    requestAnimationFrame(() => {
      setupStickyVisibilityObservers();
    });
  });

  document.addEventListener("product:rerender", function () {
    requestAnimationFrame(() => {
      setupStickyVisibilityObservers();
    });
  });

  updateStickyBar();
});